import { makeStyles } from '@material-ui/core/styles'

const styles = makeStyles(theme => ({
  notFound: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  display: {
    lineHeight: '1em',
    marginBottom: theme.spacing(4),
    fontFamily: "'Oswald'",
    fontSize: '3.4rem'
  },
  text: {
    maxWidth: 420
  }
}))

export default styles



// WEBPACK FOOTER //
// ./src/pages/NotFound/styles.js